import { ITextSearchBehavior, ITextSearchBehaviorSpecifiable } from "../../../../../../../documaker/domain/format/objects";
import { IObjectBeanTextSearchable } from "../../../beans/objects";

export class TextSearchBehaviorTranslator {
  from(bean: IObjectBeanTextSearchable): ITextSearchBehavior {
    return {
      isEnable: (bean["@search-word"] === "1"),
    };
  }

  to(o: ITextSearchBehaviorSpecifiable) {
    return {
      searchWord: o.textSearchBehavior.isEnable
        ? "1"
        : undefined,
    };
  }
}
